var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe-page"},[(_vm.iframeUrl)?_c('iframe',{attrs:{"src":_vm.iframeUrl,"frameborder":"0"}}):_c('p',[_vm._v("加载中")])])}
var staticRenderFns = []

export { render, staticRenderFns }